import { User } from '../../types/auth';
import { IAuthService } from '../interfaces/IAuthService';

/**
 * MockAuthService - For local development and testing
 * Does not require Firebase setup
 */
export class MockAuthService implements IAuthService {
  private currentUser: User | null = null;
  private listeners: Array<(user: User | null) => void> = [];

  async signInWithGoogle(): Promise<User> {
    // Simulate async operation
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Use admin email for mock Google sign-in to test admin features
    const mockUser: User = {
      uid: 'mock-admin-user',
      email: 'amit.weiss@numenos.ai',
      displayName: 'Amit Weiss (Admin)',
      photoURL: '',
    };
    
    this.currentUser = mockUser;
    this.notifyListeners(mockUser);
    
    return mockUser;
  }

  async signOut(): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 200));
    this.currentUser = null;
    this.notifyListeners(null);
  }

  getCurrentUser(): User | null {
    return this.currentUser;
  }

  onAuthStateChanged(callback: (user: User | null) => void): () => void {
    this.listeners.push(callback);
    
    // Immediately call with current state
    callback(this.currentUser);
    
    // Return unsubscribe function
    return () => {
      this.listeners = this.listeners.filter(l => l !== callback);
    };
  }

  isAuthenticated(): boolean {
    return this.currentUser !== null;
  }

  private notifyListeners(user: User | null) {
    this.listeners.forEach(listener => listener(user));
  }
}

